export { default } from './PaymentDuringSignUp.container';
export { default as PaymentDuringActivate } from './PaymentDuringActivate.container';
